<template>
  <section class="curation-tab">
    <TabView :tabs="def.parts" :selected="selectedIndex" @select="selectTab" />
    <div class="tab-contents" v-if="selectedTab">
      <CurationPartsRenderer
        :curation="curation"
        :parts="selectedTab.parts"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
interface Props {
  def: PartTab
  curation: Curation
}
const props = withDefaults(defineProps<Props>(), {})

const selectedIndex: Ref<number> = ref(0)

const selectTab = index => {
  selectedIndex.value = index
}

const selectedTab = computed(() => {
  if (props.def.parts && props.def.parts.length > 0)
    return props.def.parts[selectedIndex.value]
  return null
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.curation-tab {
  padding: 1.5rem 0rem;
  margin: 0 auto;
  .curation-tab-title {
    font-size: 1.25rem;
    margin-bottom: 1rem;
  }
  .tab-contents {
    background: $jps-gray-50;
    border-bottom: 1px solid $jps-gray-100;
    margin-top: -0.4rem;
    padding: 1rem 0;
  }

  .tabs {
    max-width: $content-width;
    margin: 0 auto;
    display: flex;
    @include is-mobile() {
      border-radius: 4px 8px 8px 4px;
      padding: 0 0.5rem;
    }
    @include is-tablet() {
      border-radius: 4px;
    }
  }
}
</style>
